import ReactHtmlParser from 'react-html-parser'
import { Group } from '@mantine/core'
import useStyles from './BookingWizardForm.styles'

interface IProps {
  color: string
  icon: any
  text: string
}

export const BookingWizardFormBanner = ({ color, icon, text }: IProps) => {
  const { classes } = useStyles()
  return (
    <>
      <div className={classes.alert} style={{ background: color }}>
        <Group noWrap align="flex-start">
          <div style={{ width: '20px' }}>{icon}</div>
          <div>{ReactHtmlParser(text)}</div>
        </Group>
      </div>
    </>
  )
}
